export enum FormError {
    GetForm = 'getForm',
    PostRatingReviewForm = 'postRatingReviewForm',
}
